export default __webpack_public_path__ + "static/media/sppirt.8d209a7b.png";